import { useLanguage } from "../i18n/LanguageContext";

export const Marquee = () => {
  const { t } = useLanguage();
  const items = [...t.marquee, ...t.marquee];

  return (
    <div
      data-testid="editorial-marquee"
      className="relative py-5 border-y border-[rgba(197,160,89,0.18)] bg-[#070707] overflow-hidden"
    >
      <div className="marquee-track flex w-max items-center gap-10">
        {items.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className="text-xs tracking-[0.34em] uppercase text-[#C5A059]">{item}</span>
            <span className="text-[#6E562A] text-[10px]">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
};
